<template>
	<div class="content-platform-content-approval" v-if="obj">
		<p>{{ contentTitle }} would like to distributes your channel.</p>
		<div><strong>Title</strong>: {{ contentTitle }}</div>
		<div v-if="contentDescription"><strong>Description</strong>: {{ contentDescription }}</div>
		<div v-if="contentThumbnail">
			<img :src="contentThumbnail" class="thumbnail-image" />
		</div>
		<div class="approval-buttons" v-if="approvalStatus === 'pending'">
			<div class="btn btn-outline-primary" @click="showApproveConfirm = true">Approve</div>
			<div class="btn btn-outline-secondary" @click="showRejectConfirm = true">Reject</div>
		</div>
		<div class="approval-text" v-if="approvalStatus === 'approved'">Approved {{ reviewDate }}</div>
		<div class="approval-text" v-if="approvalStatus === 'rejected'">Rejected {{ reviewDate }}</div>

		<v-dialog v-model="showApproveConfirm" width="400">
			<v-card>
				<v-card-text>
					<div style="padding: 25px 0 0; font-size: 14px;">Please confirm your approval.</div>
				</v-card-text>
				<v-card-actions>
					<div class="d-flex justify-space-between" style="width: 100%;">
						<div class="btn btn-primary" @click="onClickConfirmApprove" style="width: 48%; padding: 10px;">
							Confirm Approval
						</div>
						<div
							class="btn btn-secondary"
							@click="showApproveConfirm = false"
							style="width: 48%; padding: 10px;"
						>
							Cancel
						</div>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showRejectConfirm" width="400">
			<v-card>
				<v-card-text>
					<div style="padding: 25px 0 0; font-size: 14px;">Please confirm your rejection.</div>
				</v-card-text>
				<v-card-actions>
					<div class="d-flex justify-space-between" style="width: 100%;">
						<div class="btn btn-primary" @click="onClickConfirmReject" style="width: 48%; padding: 10px;">
							Confirm Rejection
						</div>
						<div
							class="btn btn-secondary"
							@click="showRejectConfirm = false"
							style="width: 48%; padding: 10px;"
						>
							Cancel
						</div>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'ContentPlatformContentApproval',
	props: {
		id: String,
	},
	data() {
		return {
			approvalId: null,
			obj: null,
			showApproveConfirm: false,
			showRejectConfirm: false,
		};
	},
	computed: {
		contentTitle() {
			return this.obj && this.obj.content ? this.obj.content.title : "";
		},
		contentDescription() {
			return this.obj && this.obj.content ? this.obj.content.description : '';
		},
		contentThumbnail() {
			return this.obj && this.obj.content ? this.obj.content.thumbnailUrl : '';
		},
		approvalStatus() {
			return this.obj.latestReview && this.obj.latestReview.status ? this.obj.latestReview.status : 'pending';
		},
		reviewDate() {
			return this.obj.latestReview ? moment(this.obj.latestReview.updatedAt).format('DD/MM/Y H:m') : '';
		},
	},
	async mounted() {
		await this.load();
	},
	methods: {
		async load() {
			const [notation, extractedId] = this.id.split(':');
			this.approvalId = extractedId;
			this.obj = await this.$repo.platform.getPlatformContentApproval(this.approvalId);
		},
		async onClickConfirmApprove() {
			this.obj = await this.$repo.platform.updatePlatformContentApprovalStatus(this.approvalId, 'approved');
			this.showApproveConfirm = false;
		},
		async onClickConfirmReject() {
			this.obj = await this.$repo.platform.updatePlatformContentApprovalStatus(this.approvalId, 'rejected');
			this.showRejectConfirm = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.content-platform-content-approval {
	p {
		margin-bottom: 10px;
	}
	.thumbnail-image {
		width: 228px;
		height: auto;
		margin: 10px 0;
	}
	.approval-buttons {
		margin-top: 15px;
		margin-bottom: 20px;

		.btn {
			padding: 8px 40px;
			font-size: 14px;

			& + .btn {
				margin-left: 20px;
			}
		}
	}
	.approval-text {
		margin-top: 15px;
	}
}
</style>
